import { v4 } from 'uuid';

export default defineNuxtPlugin(() => {
  const { $db } = useNuxtApp();
  const store = useKegelStore();
  const route = useRoute();
  let user: string = '';
  const cookieUuid = useCookie('user-uuid', {
    default: () => '',
    maxAge: 7 * 24 * 60 * 60,
  });
  $db.getItem('user-uuid').then((userId: any) => {
    user = userId as string || route.query?.user_uuid as string || cookieUuid.value as string;
    if (!user) {
      user = v4().replaceAll('"', '');
      $db.setItem('user-uuid', user);
      store.userUuid = String(user);
      cookieUuid.value = user;
    } else {
      cookieUuid.value = user;
      store.userUuid = user;
      $db.setItem('user-uuid', user);
    }
  });
});
